<mat-sidenav-container class="sidenav-container">

  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="isSideNavOpened" (mouseenter)="mouseenter()"
    (mouseleave)="mouseleave()">
    <mat-toolbar class="bg-dark-gray text-white name-toolbar mat-elevation-z3"
      style="font-size: larger; font-weight: bold; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); background-color: #496989;background-image: linear-gradient(to bottom, #598fbb92, #1e2a3670);">
      <span *ngIf="isLoggedIn()" (click)="closeSidenav()" routerLink="/about" matTooltip="{{name}}"
        matTooltipPosition="above"
        style="position: relative; overflow: hidden; white-space:break-spaces; word-break:break-word;color: #cbd8e6; font-size: medium;">
        {{name}}

        <!-- <span class="name-ellipsis" style="position: absolute; top: 0; left: 0; z-index: 0; color: #cbd8e6; text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);">{{name}}</span> -->
      </span>
      <a aria-label="Toggle sidenav" mat-icon-button (click)="toggleSideNav()"
        style="right: 5%; position: absolute;float: right; display: inline-block;">
        <mat-icon>close</mat-icon>
      </a>
    </mat-toolbar>


    <mat-nav-list class="mt-3" >
      <div style="display: flex; justify-content: space-between; align-items: center;margin-left: 15px;"
        *ngIf="isLoggedIn()" routerLink="/about" (click)="closeSidenav()">
        <mat-icon style="margin-right: -7px; cursor: pointer;">person</mat-icon>
        <a mat-list-item style="margin-left: 5px;"> <span class="nav-text smaller-text">Profile</span></a>
      </div>

      <div style="display: flex; justify-content: space-between; align-items: center;margin-left: 15px;"
        *ngIf="!isLoggedIn()" routerLink="/login" (click)="closeSidenav()">
        <mat-icon style="margin-right: -7px; cursor: pointer;">login</mat-icon>
        <a mat-list-item style="margin-left: 5px;"> <span class="nav-text smaller-text">Login</span></a>
      </div>

      <div style="display: flex; justify-content: space-between; align-items: center;margin-left: 15px;"
        *ngIf="!isLoggedIn()" routerLink="/register" (click)="closeSidenav()">
        <mat-icon style="margin-right: -7px;cursor: pointer;">account_box</mat-icon>
        <a mat-list-item style="margin-left: 5px;"> <span class="nav-text smaller-text">Register</span></a>
      </div>

      <div style="display: flex; justify-content: space-between; align-items: center;margin-left: 15px;"
        *ngIf="isLoggedIn()" routerLink="/scaned-receipts" (click)="closeSidenav()">
        <mat-icon style="margin-right: -7px;cursor: pointer;">receipt</mat-icon>
        <a mat-list-item style="margin-left: 5px;"> <span class="nav-text smaller-text">Scanned Receipts</span></a>
      </div>


      <div style="display: flex; justify-content: space-between; align-items: center;margin-left: 15px;"
        *ngIf="isLoggedIn()" routerLink="/organization-management" (click)="closeSidenav()">
        <mat-icon style="margin-right: -7px; cursor: pointer;">business</mat-icon>
        <a mat-list-item style="margin-left: 5px;"> <span class="nav-text smaller-text">Organization</span></a>
      </div>

      <div style="display: flex; justify-content: space-between; align-items: center;margin-left: 15px;"
        *ngIf="isLoggedIn()" routerLink="/trip" (click)="closeSidenav()">
        <mat-icon style="margin-right: -7px; cursor: pointer;">map</mat-icon>
        <a mat-list-item style="margin-left: 5px;"> <span class="nav-text smaller-text">Trip</span></a>
      </div>

      <div style="display: flex; justify-content: space-between; align-items: center;margin-left: 15px;"
        *ngIf="isLoggedIn()" (click)="toggleSubList()">
        <mat-icon style="margin-right: -7px; cursor: pointer;">{{ isSubListVisible ? 'expand_more':'chevron_right'
          }}</mat-icon>
        <a mat-list-item style="margin-left: 5px;">
          <span class="nav-text smaller-text">Requests</span>
        </a>

      </div>
      <div class="col-sm-12" *ngIf="isLoggedIn() && isSubListVisible">
        <mat-nav-list>

          <div class="row ml-3" style="margin-left:20%" *ngIf="hasRole('OrganizationAdmin')"
            mat-list-item routerLink="/showOrgRequest" (click)="closeSidenav()">
            <div class="col-sm-2">
              <mat-icon style="cursor: pointer;">apartment</mat-icon>
            </div>
            <div class="col-sm-10">
              <a>
                <span class="nav-text smaller-text" style="cursor: pointer;">Managment Requests</span>
              </a>
            </div>
          </div>

          <div class="row ml-3" style="margin-left:20%" mat-list-item routerLink="/showRequest"
            (click)="closeSidenav()">
            <div class="col-sm-2">
              <mat-icon style="cursor: pointer;">manage_accounts</mat-icon>
            </div>
            <div class="col-sm-10">
              <a>
                <span class="nav-text smaller-text" style="cursor: pointer;">User Requests</span>
              </a>
            </div>
          </div>
        </mat-nav-list>
      </div>
      <div style="display: flex; justify-content: space-between; align-items: center;margin-left: 15px;"
        *ngIf="isLoggedIn()" routerLink="/logout" (click)="closeSidenav()">
        <mat-icon style="margin-right: -7px; cursor: pointer;">logout</mat-icon>
        <a mat-list-item style="margin-left: 5px;"> <span class="nav-text smaller-text">Logout</span></a>
      </div>
    </mat-nav-list>

  </mat-sidenav>

  <mat-sidenav-content class="d-flex flex-column" >


    <mat-toolbar style="background-color:  #496989;background-image: linear-gradient(to bottom, #598fbb92, #1e2a3670);" class="text-white mat-elevation-z3">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="toggleSideNav()"
        *ngIf="isHandset$ && !isSideNavOpened">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <span style="color: transparent; color: rgb(238, 238, 238) ; font-weight: bold;font-size: 28px;display: block;margin: 0 auto;">{{ toolbarHeadline }}</span>
      <span style="display: flex; align-items: center;">
        <!-- Replace the text with an <img> tag pointing to your logo image -->
        <a routerLink="/" class="text-white"
          style="text-decoration: none; font-size: 24px; font-weight: bold; position: relative; display: flex; align-items: center;">
          <img src="assets/logo2.png" alt="Logo" style="height: 60px; width: auto; margin-right: 10px; z-index: 2;">
          <!-- Add a transparent text shadow for better visibility on the dark background -->
          <span style="color: transparent; color: rgb(124, 179, 246) ; font-size: 28px;">RollingExpenses</span>
        </a>
        <button mat-icon-button (click)="toggleNotificationPanel()" *ngIf="isLoggedIn()">
          <mat-icon aria-label="Notifications" style="color: rgb(226, 220, 212);">notifications</mat-icon>
        </button>
              </span>
    </mat-toolbar>
    <app-notification-panel-component [isOpen]="notificationPanelOpen"></app-notification-panel-component>
    <div style="flex:1">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>